export default __webpack_public_path__ + "static/media/na-ai.3c936ad7.png";